// store/authStore.js
import { create } from "zustand";
import { deleteTestimonial, getTestimonial, getTestimonialByID, getTotalTestimonial, postTestimonial, postTestimonialdata } from "../api/testimonial";

export const useTestimonialStore = create((set, get) => ({
    loading: true,
    testimonial: [],
    testimonialPage: null,
    totalTestimonial:null,

    getTestimonialById: async (id) => {
        try {
            set({ loading: true })
            const res = await getTestimonialByID(id)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    getTestimonialPage: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true });
            const res = await getTestimonial(pageNumber, pageSize, search, field);
            set({
                loading: false,
                testimonial: res?.ref,
                testimonialPage: res?.testimonialPage,
            });
            return res;
        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    postTestimonial: async (formData, id) => {
        try {
            set({ loading: true });
            const res = await postTestimonial(formData);
            set({
                loading: false,
            });
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    deleteTestimonial: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteTestimonial(id)
            if (res) {
                const currentTestimonial = get().testimonial || [];
                const updatedTestimonial = currentTestimonial.filter((ele) => ele._id !== id);
                set({ loading: false, testimonial: updatedTestimonial });
            }
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    postTestimonialPageData: async (form) => {
        try {
            set({ loading: true })
            const res = await postTestimonialdata(form)
            set({ loading: false })
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    gettotaltestimonial: async () => {
        try {
            set({ loading: true })
            const res = await getTotalTestimonial()
            console.log(res)
            set({ loading: false, totalTestimonial: res })
            return res
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },

}));
